// extracted by mini-css-extract-plugin
export default {"tabDashboardUsage":"TabDistributorsUsage_tabDashboardUsage__P-Id+","rangeSelect":"TabDistributorsUsage_rangeSelect__6nv2n","card":"TabDistributorsUsage_card__+zJxp"};